import {
  SET_ASSET_DETAILS_ID,
  SET_ASSET_DETAILS_LAYOUT,
  SET_DONT_SHOW_PRESENTER_SETTING,
  SET_PAGE_LAYOUT,
  SET_PRESENTER_MODE,
  SET_SUMMARIES_LAYOUT,
  SET_VISIBLE_PRESENTER_COMPONENTS,
} from '../actions/actionTypes';
import { LayoutAction, LayoutStateType } from '../context';

export default (
  state: LayoutStateType,
  action: LayoutAction,
): LayoutStateType => {
  switch (action.type) {
    case SET_PAGE_LAYOUT:
      return {
        ...state,
        pageLayout: action.payload,
      };
    case SET_ASSET_DETAILS_LAYOUT:
      return {
        ...state,
        assetDetailsLayout: action.payload,
      };
    case SET_PRESENTER_MODE:
      return {
        ...state,
        presenterModeActive: action.payload,
      };
    case SET_VISIBLE_PRESENTER_COMPONENTS:
      return {
        ...state,
        visiblePresenterComponents: action.payload,
      };
    case SET_DONT_SHOW_PRESENTER_SETTING:
      return {
        ...state,
        dontShowPresenterSetting: action.payload,
      };
    case SET_SUMMARIES_LAYOUT:
      if (action.payload === 'collapsed') {
        return {
          ...state,
          summariesLayout: action.payload,
        };
      }
      return {
        ...state,
        summariesLayout: action.payload,
        assetDetailsAssetId: null,
        lastAssetDetailsAssetIdUpdate: new Date(),
      };
    case SET_ASSET_DETAILS_ID:
      if (action.payload) {
        return {
          ...state,
          assetDetailsAssetId: action.payload.assetDetailsAssetId,
          lastAssetDetailsAssetIdUpdate: action.payload.manual
            ? new Date()
            : state.lastAssetDetailsAssetIdUpdate,
        };
      }
      return {
        ...state,
        assetDetailsAssetId: null,
      };
    default:
      return state;
  }
};
